import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { TsrctDemandStatus } from '@/generated/gql/graphql';
import { DemandStatusChip } from '~/components/DemandStatusChip/DemandStatusChip';

export type DemandStateChipCellValue = Union.Nullable<keyof typeof TsrctDemandStatus>;

interface DemandStateChipCellProps<R extends GridValidRowModel = any> {
  value: DemandStateChipCellValue;
  row: R;
}

export const DemandStatusChipCell = <R extends GridValidRowModel = any>({ value }: DemandStateChipCellProps<R>) => {
  // div wrapper needed to display chip correctly
  return value ? (
    <div>
      <DemandStatusChip status={value} />
    </div>
  ) : (
    <>{NULLISH_CELL_VALUE}</>
  );
};
